import {DatabaseCode, toDatabaseCode} from "./database-code";

export type NoticeKind = DatabaseCode;

const notice: NoticeKind = {
  code: "NOTICE",
  displayValue: {
    id: "common.entity.noticekind.notice",
    defaultMessage: "Notice",
  },
};

const advisory: NoticeKind = {
  code: "ADVISORY",
  displayValue: {
    id: "common.entity.noticekind.advisory",
    defaultMessage: "Advisory",
  },
};

export const noticeKind = {
  notice,
  advisory,
};

export const noticeKinds = Object.values(noticeKind);

export const toNoticeKind = (code: string): NoticeKind =>
  toDatabaseCode(code, noticeKinds);

export const toNoticeKindSafely = (code: string | undefined): NoticeKind | undefined =>
  code ? toDatabaseCode(code, noticeKinds) : undefined;
